/**
 * Lib.Common: v-date directive
 *
 * Populate element content with formatted date.
 */


import $date from '../prototype/date';

const emDash = '—';


function update(el, binding) {
    const value = binding.value;
    const state = el.__date__;
    if (value !== state.v) {
        const html = state.fn(value);
        const nan = html === emDash;
        if (nan != state.n) {
            if (nan) {
                el.classList.add('_nan');
            } else {
                el.classList.remove('_nan');
            }
        }
        el.innerHTML = html;
        const mod = binding.modifiers;
        state.v = (mod.ago || mod.agoLong) ? void 0 : value;
        state.n = nan;
    }
}

function bind(el, binding) {
    const mod = binding.modifiers;
    //const boldMonth = mod.boldMonth;
    //const boldDay = mod.boldDay;
    //const boldHour = mod.boldHour;

    let fn =
        mod.iso         ? $date.iso :
        mod.isodate     ? $date.isodate :
        mod.ago         ? $date.ago :
        mod.agoLong     ? $date.agoLong :
        mod.hm          ? $date.hm :
        mod.hms         ? $date.hms :
        mod.hmsz        ? $date.hmsz :
        mod.hhmm        ? $date.hhmm :
        mod.hhmmss      ? $date.hhmmss :
        mod.hhmmssz     ? $date.hhmmssz :
        mod.m           ? $date.m :
        mod.d           ? $date.d :
        mod.y           ? $date.y :
        mod.mdy         ? $date.mdy :
        mod.mdyhm       ? $date.mdyhm :
        mod.mdyhms      ? $date.mdyhms :
        mod.mdyhmsz     ? $date.mdyhmsz :
        mod.mm          ? $date.mm :
        mod.dd          ? $date.dd :
        mod.yy          ? $date.yy :
        mod.mmdd        ? $date.mmdd :
        mod.mmddyy      ? $date.mmddyy :
        mod.mmm         ? $date.mmm :
        mod.mmmd        ? $date.mmmd :
        mod.mmmy        ? $date.mmmy :
        mod.mmmdy       ? $date.mmmdy :
        mod.mmmm        ? $date.mmmm :
        mod.mmmmd       ? $date.mmmmd :
        mod.mmmmy       ? $date.mmmmy :
        mod.mmmmdhm     ? $date.mmmmdhm :
        mod.mmmmdy      ? $date.mmmmdy :
        mod.wmmmmdy     ? $date.wmmmmdy :
        mod.short       ? $date.short :
        mod.long        ? $date.long :
                          $date.mdy;

    el.__date__ = {
        fn,
        v: !binding.value,
        n: false
    };
    update(el, binding);
}

function unbind(el) {
    el.innerHTML = '';
}

export default {
    name: 'date',
    directive: {
        bind,
        unbind,
        update
    }
};
